<!--九宫格-->
<template>
  <table border="1" :class="{nine:!highLight,'nine-high-light':highLight}">
    <tr>
      <td></td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td></td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td></td>
      <td></td>
      <td></td>
    </tr>
  </table>
</template>

<script>
export default {
  name: "NineSquares",
  props: {
    'highLight': {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
$colorMain: #28CCCB;

table.nine {
  border-collapse: collapse;
  margin-left: auto;
  margin-right: auto;

  > tr {
    > td {
      width: 4px;
      height: 4px;
    }
  }
}

table.nine:hover {
  cursor: pointer;
  border-top: 1px solid $colorMain;
  border-left: 1px solid $colorMain;

  > tr {
    > td {
      border-bottom: 1px solid $colorMain;
      border-right: 1px solid $colorMain;
    }
  }
}

table.nine-high-light {
  border-collapse: collapse;
  margin-left: auto;
  margin-right: auto;
  border-top: 1px solid $colorMain;
  border-left: 1px solid $colorMain;

  > tr {
    > td {
      width: 4px;
      height: 4px;
      border-bottom: 1px solid $colorMain;
      border-right: 1px solid $colorMain;
    }
  }
}

table.nine-high-light:hover {
  cursor: pointer;
}
</style>
